import {
    CASHLIFTINGLIST_SUCCESS,
    CASHLIFTINGLIST_FAILED,
    RESET_CASHLIFTINGLIST,
    LOADING_CASHLIFTINGLIST,
    CASHLIFTINGLIST_NETWORKERROR,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_CASHLIFTINGLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case CASHLIFTINGLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case CASHLIFTINGLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case CASHLIFTINGLIST_NETWORKERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_CASHLIFTINGLIST:
            return (state = initialState);
        default:
            return state;
    }
};
